(function () {
  if (window.__llHeaderCompactInit) return;
  window.__llHeaderCompactInit = true;

  var SCROLL_THRESHOLD = 12;
  var ticking = false;

  function sections() {
    return document.querySelectorAll('.header-section');
  }

  function apply() {
    var compact = window.scrollY > SCROLL_THRESHOLD;
    sections().forEach(function (section) {
      section.classList.toggle('ll-header--compact', compact);
    });
    ticking = false;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(apply);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  apply();
})();
